import debounce from 'debounce';

// header... of the site
document.addEventListener('DOMContentLoaded', function () {
  class HeaderSite extends HTMLElement {
    constructor() {
      super();
      // elements
      this.burgerSelector = '.js-header__burger';
      this.menuId = document.querySelector(this.burgerSelector)?.getAttribute('aria-controls');
      this.mobileMenu = this.menuId ? document.getElementById(this.menuId) : null;
    }
    connectedCallback() {
      // props
      this.scrolled = 0;
      // binding
      this.bndHandleScroll = this.handleScroll.bind(this);
      this.bndHandleResize = debounce(this.handleScroll.bind(this), 250);
      this.bndToggleMenu = this.toggleMenu.bind(this);
      // events
      this.onLoad();
      window.addEventListener('scroll', this.bndHandleScroll);
      window.addEventListener('resize', this.bndHandleResize);
      window.addEventListener('click', this.bndToggleMenu);

      // Store original aria-label on burger button
      const burgerButton = document.querySelector(this.burgerSelector);
      if (burgerButton && !burgerButton.hasAttribute('data-label-open')) {
        const originalLabel = burgerButton.getAttribute('aria-label');
        if (originalLabel) {
          burgerButton.setAttribute('data-label-open', originalLabel);
        }
      }
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.bndHandleScroll);
      window.removeEventListener('resize', this.bndHandleResize);
      window.removeEventListener('click', this.bndToggleMenu);
    }
    onLoad() {
      this.scrolled = window.scrollY;
      this.handleScroll();
    }
    handleScroll() {
      // console.log('scrolling', window.scrollY, scrollPosition)
      if (window.scrollY >= 100 && window.scrollY >= this.scrolled) {
        // console.log('scroll -> down')
        this.setAttribute('data-scrolled', 'down');
      } else if (window.scrollY >= 100 && window.scrollY < this.scrolled) {
        // console.log('scroll -> up')
        this.setAttribute('data-scrolled', 'up');
      } else {
        // console.log('scroll -> default')
        this.setAttribute('data-scrolled', 'default');
      }
      this.scrolled = window.scrollY;
    }
    toggleMenu(e) {
      const trigger = e.target.closest(this.burgerSelector);
      if (!trigger) return;
      e.preventDefault();

      // Use the mobile-menu component's methods
      if (this.mobileMenu && typeof this.mobileMenu.toggleMenu === 'function') {
        this.mobileMenu.toggleMenu(trigger);

        // Update aria-expanded attribute
        const isExpanded = document.body.classList.contains('is-with-menu');
        trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

        // Switch between aria-label and data-label-close based on menu state
        if (isExpanded) {
          // Menu is open - use close label
          const closeLabel = trigger.getAttribute('data-label-close');
          if (closeLabel) {
            trigger.setAttribute('aria-label', closeLabel);
          }
        } else {
          // Menu is closed - use original label (stored in data-label-open if not present)
          const originalLabel = trigger.getAttribute('data-label-open') || trigger.getAttribute('aria-label');
          if (originalLabel) {
            trigger.setAttribute('aria-label', originalLabel);
          }
        }
      }
    }
  }
  customElements.define('header-site', HeaderSite);
});